<!--
 * @Description: 服务事项主体部分页面
 * @Author: sunhuihong
 * @Date: 2022-05-23 14:43:52
 * @LastEditTime: 2022-11-01 12:59:10
-->
<template>
  <div class="view-service-item">
    <div class="view-service-item-left">
      <div class="view-service-item-left-title">
        <div>
          <span class="title-line"></span>
          <span style="font-size: 15px; color: #000000; font-weight: 600;">注意事项组</span>
        </div>
        <el-button v-if="matterPrivilege && matterPrivilege.canAdd" type="text" icon="el-icon-circle-plus" 
          class="add-group-button" @click="handleAddGroup" >
          新增组
        </el-button>
      </div>
      <el-input size="small" v-model="filterServiceItemGroup" suffix-icon="el-icon-search" 
        placeholder="输入关键字进行过滤" >
      </el-input>
      <el-tree :style="treeHeight" class="tree-style" :data="listServiceItemData" :props="defaultProps" ref="tree"
        node-key="id" :default-expanded-keys="[choiceId]" :filter-node-method="filterNode"  highlight-current
        @node-click="deptNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }" @mouseover="mouseover(data)" 
          @mouseleave="mouseout(data)">
          <span class="tree-label">
            {{ node.label }}
          </span>
          <div  v-show="data.dropdownShow" style="flex: 1; text-align: right">
            <el-dropdown placement="bottom-end" trigger="hover" size="medium">
              <img class="tree-more" src="@/assets/hsvcmng/icon-hsvcmng-more.png" alt="" >
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="matterPrivilege && matterPrivilege.canAdd" 
                  @click.native="handleAddTemplate(node,data)" v-show="data.parentId == 0">
                  新增模板
                </el-dropdown-item>
                <el-dropdown-item v-if="matterPrivilege && matterPrivilege.canUpdate" 
                  @click.native="handleEditName(node,data)">
                  修改名称
                </el-dropdown-item>
                <el-dropdown-item v-if="matterPrivilege && matterPrivilege.canDelete" 
                  @click.native="handleDeleteGroup(node,data)">
                  {{data.parentId == 0 ? '删除分组' : '删除模板'}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </span>
      </el-tree>
    </div>
    <div class="main-line" :style="lineHeight"></div>
    <div class="view-service-item-right">
      <el-row style="margin: 12px 10px 10px 35px;">
        <el-form :rules="rules" :model="ruleForm" ref="ruleForm" v-show="showContent">
          <el-form-item  prop="content" >
            <div style="margin: 0 0 10px 0; font-weight: 400; color: #657180;">{{title}}:</div>
            <el-input  type="textarea" ref="content" v-model="ruleForm.content" max="500" :disabled="readonly" 
              maxlength="500" :rows="16" placeholder="请输入注意事项" style="width: 70%;">
            </el-input>
          </el-form-item>
          <div v-if="matterPrivilege && matterPrivilege.canUpdate">
            <el-button @click="handleCancel"  class="edit-button-style" v-if="cancleButton">
              取 消
            </el-button>
            <el-button type="primary" class="edit-button-style" v-else @click="handleEditContent">
              修 改
            </el-button>
            <el-button type="primary" class="submit-button-style" v-show="showSubmitButton"
              @click="handleSubmit('ruleForm')">
              确 定
            </el-button>
          </div>
        </el-form>
      </el-row>
    </div>
  </div>
</template>
<script>
import Constant from '@/global/Constant.js'
export default {
  name: "ServiceItemContainer",
  props: ["listServiceItemData", "institutionId", "matterPrivilege", "listContent"],

  data() {
    let validateContent = (_rule, _value, callback) => {
			if (this.ruleForm.content && this.ruleForm.content.trim().length == 0) {
				callback(new Error('注意事项不能输入全空格或全换行'));
			} else if (this.ruleForm.content == '') {
				callback(new Error('请输入注意事项'));
			} else {
        callback();
      }
    };

    return {
      filterServiceItemGroup: '',
      defaultProps: {
        children: 'matterDTOList',
        label: 'name',
     }, 
      id: this.listContent.matterDTOList.length ? this.listContent.matterDTOList[0].id : '',
      choiceId: this.listServiceItemData[0].id,
      ruleForm: {
        name: this.listContent.matterDTOList.length ? this.listContent.matterDTOList[0].name : '',
        parentId: this.listContent.matterDTOList.length ? this.listServiceItemData[0].parentId : '',
        content: this.listContent.matterDTOList.length ? this.listServiceItemData[0].content :'',
      },
      showContent: this.listContent.matterDTOList.length ? true : false,
      showSubmitButton: false,
      title: '注意事项',
      readonly: true,
      cancleButton: false,
      rules: {
        content: [
          { required: true, validator: validateContent, trigger: 'blur'},
          { min: 1, max: 500, message: '长度在 1 到 500个字符', trigger: 'blur' }
        ],     
      },
    }
  },

  computed: {
    lineHeight() {
      return 'height:' + (this.$root.windowHeight - 60) + 'px';
    },

    treeHeight() {
      return 'height:' + (this.$root.windowHeight - 142) + 'px';
    },  
  },

  watch: {
    filterServiceItemGroup(val) {
      this.$refs.tree.filter(val);
    },

    listServiceItemData(data) {
      //第一次的choiceId设置为第一个数据，若之后设置了选中则无需更改
      this.choiceId = !this.choiceId  ? data[0].id : this.choiceId;
      //设置选中
      this.$nextTick(() => {
        if (data.length && data[0].matterDTOList.length) {
          this.$refs.tree.setCurrentKey(data[0].matterDTOList[0].id)
        } else {
          this.$refs.tree.setCurrentKey(this.choiceId)
        }
      })
      this.ruleForm.content = data[0].matterDTOList.length ?  data[0].matterDTOList[0].content : '';
      this.id = data[0].matterDTOList.length ? data[0].matterDTOList[0].id : '';
      this.ruleForm.parentId = data[0].matterDTOList.length ? data[0].id : '';
      this.ruleForm.name = data[0].matterDTOList.length ? data[0].matterDTOList[0].name : '';
    },

    listContent(newVal,_oldVal) {
      if (newVal && Object.keys(newVal).length) {
        this.choiceId = newVal.id;
        this.showContent = newVal.matterDTOList && newVal.matterDTOList.length ? true : false;
      }
    }
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    // 移入
    mouseover (data) { 
      this.$set(data, 'dropdownShow', true)
    },

    // 移除
    mouseout (data) { 
      this.$set(data, 'dropdownShow', false)
    },
    
    //新增组
    handleAddGroup() {
      if (this.institutionId == '') {
        this.$message.error( "请先选择机构");
        return false;
      }
      this.$emit("handle-add-group",true)
    },
    
    //新增模板
    handleAddTemplate(_node,data) {
      if (this.institutionId == '') {
        this.$message.error( "请先选择机构");
        return false;
      }
      this.$refs.content.focus();
      this.cancleButton = true;
      this.readonly = false;
      this.showSubmitButton = true;
      this.$emit("handle-add-template", data);
    },

    //编辑组或者模板
    handleEditName(_node,data) {
      if (this.institutionId == '') {
        this.$message.error( "请先选择机构");
        return false;
      }
      this.choiceId = data.id
      this.$emit("handle-edit-name", data);
    },
    
    //删除组或者模板
    handleDeleteGroup(_node,data) {
      if (this.institutionId == '') {
        this.$message.error( "请先选择机构");
        return false;
      }
      this.$emit("handle-delete-group", data);
    },

    //编辑注意事项内容
    handleEditContent() {
      if (this.institutionId == '') {
        this.$message.error( "请先选择机构");
        return false;
      }
      this.readonly = false;
      this.showSubmitButton = true;
    },
    
    //编辑成功后确认提交编辑的注意事项
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if(!valid)return false;
        this.ruleForm.id = this.id;
        this.ruleForm.institutionId = this.institutionId;
        this.appAxios("PUT",Constant.URL_UPDATE_MATTER,this.ruleForm).then((result) => {
          if (result == null) {
            return;
          }
          this.$parent.listHsvcMatterTree();
          this.$message({message: '保存成功', type: 'success'});
        })
      }) 
    },

    deptNodeClick(item,_e) {
      this.showContent = item.parentId == 0 ? false : true;
      this.ruleForm.content = item.content;
      this.ruleForm.parentId = item.parentId;
      this.ruleForm.name = item.name;
      this.id = item.id;
    },

    handleCancel() {
      this.ruleForm.content = '';
    },
  },

  mounted() {
    if (this.listServiceItemData[0].matterDTOList.length) {
      this.$refs.tree.setCurrentKey(this.listServiceItemData[0].matterDTOList[0].id);
    } else {
      this.$refs.tree.setCurrentKey(this.listServiceItemData[0].id);
    }
  },
}
</script>

<style>
.view-service-item-right .el-textarea__inner {
  padding: 16px 30px 12px 16px;
}
</style>
<style scoped >
.view-service-item {
  display: flex;
  justify-content: space-between;
}

.view-service-item-left {
  padding: 0px 23px 16px 21px;
  width: 250px;
}

.view-service-item-left-title {
  display: flex;
  justify-content: space-between;
  line-height: 40px;
}

.title-line {
  display: inline-block;
  width: 4px;
  height: 14px;
  background: #3E7EF5;
  border-radius: 2px;
  vertical-align: middle;
  margin-right: 4px;
}

.main-line {
  width: 10px;
  background-color: #f0f0f0;
}

.add-group-button {
  font-size: 14px;
}

.tree-style{
  margin-top: 10px;
  overflow-y: auto;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 10px;
  height: 100%;
}

.tree-more {
  width: 14px;
  height: 14px;
}

.view-service-item-right {
  flex: 1;
  text-align: left;
}

.edit-button-style {
  width: 80px;
  height: 30px;
  line-height: 5px;
}

.submit-button-style {
  width: 80px;
  height: 30px;
  line-height: 5px;
}

.custom-tree-node .tree-label {
  width: 160px; 
  text-align: left; 
  color: #7689A6; 
  font-size: 14px; 
  overflow: hidden; 
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/hsvcmng/components/hsvcmatter/ServiceItemContainer.vue